import { createConfiguration, Time } from "@hyper-fetch/core";

import type { ApiRoutesSdk } from "@inginuiti/backend";

export const notificationsConfiguration = createConfiguration<ApiRoutesSdk>()({
  "notifications.$get": { cacheTime: Time.SEC * 30 },
});
